import {configureStore} from '@reduxjs/toolkit';
import settingsReducer from './SettingsSlice';
import authReducer from './AuthSlice';
import commonReducer from './CommonSlice';
import dictionaryReducer from './DictionarySlice';

export const store = configureStore({
    reducer: {
        settings: settingsReducer,
        auth: authReducer,
        common: commonReducer,
        dictionary: dictionaryReducer
    },
});
